<template>
  <el-dialog
  v-if="dialogVisible"
    class="expansion-view-msg-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <div class="msg-info">
      {{ info }}
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleCancel">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ViewMessage',
  data() {
    return {
      title: '',
      info: '',
      dialogVisible: false
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
      this.title = ''
      this.info = ''
    },
    handleOpen(data, title) {
      this.title = title
      this.info = data
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.expansion-view-msg-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .msg-info {
    padding: var(--base-size-16);
  }
}
</style>
